import React from 'react';
import { Link } from 'react-router-dom';
import { pathJoin } from '../../../../services/api';
import { Add, EditSchedule, Delete, Edit, AddSchedule } from '../../../shared/actions/actionButtons';
import { QueryGrid } from '../../../shared/grid/queryGrid/queryGrid';

import styles from './zipcodeList.module.css';
import { ZIPCODE } from '../../../../permissions';

/**
 * @param {Object} props
 * @param {number?} [props.scope=null] Branch Id. Use null for all
 * @param {number?} [props.maxResults=null] Max Results per page
 */
export const ZipcodeList = (props) => {
    return <QueryGrid
        queryParamPrefix=''
        singleResourceName='Zip Code'
        pluralResourceName='Zip Codes'
        nameFunction={r => r.zip + ', ' + r.city}
        restEndpoint='/locations/zipcodes'
        listUrl='/locations/zipcodes'
        actions={[Add, Edit, Delete, EditSchedule]}
        readPermissions={[ZIPCODE.READ]}
        writePermissions={[ZIPCODE.WRITE]}
        columns={{
            zip: {
                label: 'Zip Code',
                size: 0.5,
                passOnClick: true,
                formatFunction: r => <Link to={pathJoin('/locations/zipcodes', r.id)}>{r.zip}</Link>
            },
            city: {
                label: 'Name',
                formatFunction: r => r.city
            },
            'schedule.branch.name': {
                label: 'Branches',
                formatFunction: r => (!r.schedules || r.schedules.length === 0) ?
                        'None'
                    :
                    r.schedules.map((s, i) => <>
                        {i !== 0 ? ', ' : ''}
                        <Link key={s.branch?.id} to={pathJoin('/locations/branches', s.branch?.id)}>{s.branch?.name ?? ''}</Link>
                    </>)
            },
            note: {
                label: 'Notes',
                size: 1.5,
                sortable: false,
                formatFunction: r => r.note
            }
        }}
        {...props}
    />
}